import { Suspense } from 'react';
import { PageWrapper } from '../Wrapper';
import { TableSkeleton, FormSkeleton, PageSkeleton } from '../ui';

interface ILazyLoadComponent {
    Component: React.ReactNode;
    type?: 'PAGE' | 'LIST' | 'FORM';
}
export function LazyLoadComponent({
    Component,
    type = 'PAGE',
}: Readonly<ILazyLoadComponent>) {
    function fallback() {
        switch (type) {
            case 'FORM':
                return (
                    <PageWrapper>
                        <FormSkeleton />
                    </PageWrapper>
                );
            case 'LIST':
                return <TableSkeleton />;

            default:
                return <PageSkeleton />;
        }
    }
    return <Suspense fallback={fallback()}>{Component}</Suspense>;
}
